import React from 'react';
import Card from '../../common/cards/Card.jsx';
import FrameworkAgreementsDetails from './FrameworkAgreementsDetails.jsx';

export default function FrameworkAgreementsListCard({
    context,
    frameworkAgreement,
    showActionButton = false,
}) {

    return (
        <div className="col-12 mb-3">
            <Card>

                <div className="card-header text-gc-dark-blue p-0">
                    <FrameworkAgreementsDetails
                        context={context}
                        frameworkAgreement={frameworkAgreement}
                        containerType={'list'}
                        showActionButton={showActionButton}
                    />
                </div>

            </Card>
        </div>
    );

}
